export const suggestionChange = 'address.suggestionChange';
export const addressSelect = 'address.select';
export const validateAddress = 'address.validate';
export const addJkMarkers = 'address.addJkMarkers';
export const removeJkMarkers = 'address.removeJkMarkers';
export const selectJk = 'address.selectJk';
export const selectJkHouse = 'address.selectJkHouse';
export const mapDragEnd = 'address.mapDragEnd';
export const mapReady = 'address.mapReady';
export const updateMap = 'address.updateMap';
export const resetValidation = 'address.resetValidation';
export const setGeoObject = 'address.setGeoObject';
export const geoObjectUpdate = 'address.geoObjectUpdate';
/**
 * Статус запроса в geocode. Событие распространяется с параметром.
 *
 * @param {boolean} true — перед отправкой запроса в geocode, false — после получения ответа geocode
 */
export const geoObjectProcessed = 'address.geoObjectProcessed';
export const getSuggestionsForInput = 'address.getSuggestionsForInput';
export const locationPathChanged = 'addform.changeLocationPath';
/** Изменённые данные адреса записались в addressService */
export const addressChanged = 'geo.address.changed';
export const setBSCenterAddress = 'address.setBSCenterAddress';
export const geocodeStart = 'address.geocodeStart';
